import { Type } from '@angular/core';
import { IDinamikBilesenKayit, IDinamikBilesenMeta, IDinamikBilesenTanim } from '../../../interfaces/IDinamikBilesen.interface';

class _DinamikBilesenRegistry {
  private kayitlar = new Map<string, IDinamikBilesenKayit>();
  private cache = new Map<string, IDinamikBilesenTanim>();
  private yuklemeler = new Map<string, Promise<IDinamikBilesenTanim | null>>();

  kaydet(id: string, tanim: IDinamikBilesenTanim, meta?: IDinamikBilesenMeta) {
    const mevcut = this.kayitlar.get(id);
    if (mevcut) {
      mevcut.tanim = tanim;
      mevcut.meta = meta;
    } else {
      this.kayitlar.set(id, { id, yukleyici: () => Promise.resolve(tanim), tanim, meta });
    }
    this.cache.set(id, tanim);
  }

  kaydetLazy(id: string, yukleyici: () => Promise<any>) {
    if (!this.kayitlar.has(id)) {
      this.kayitlar.set(id, { id, yukleyici });
    }
  }

  kaydetToplu(moduller: Record<string, () => Promise<any>>) {
    for (const [yol, yukleyici] of Object.entries(moduller)) {
      const parcalar = yol.replace(/\\/g, '/').split('/');
      const dosyaAdi = parcalar[parcalar.length - 1];
      const id = dosyaAdi.replace('.dinamik-bilesen.ts', '');
      this.kaydetLazy(id, yukleyici);
    }
  }

  async yukle(id: string): Promise<IDinamikBilesenTanim | null> {
    if (this.cache.has(id)) return this.cache.get(id)!;

    const aktif = this.yuklemeler.get(id);
    if (aktif) return aktif;

    const kayit = this.kayitlar.get(id);
    if (!kayit) return null;

    const p = kayit.yukleyici()
      .then(() => this.cache.get(id) || kayit.tanim || null)
      .finally(() => this.yuklemeler.delete(id));

    this.yuklemeler.set(id, p);
    return p;
  }

  async onceden_yukle(idler: string[]): Promise<void> {
    await Promise.all(idler.map(id => this.yukle(id)));
  }

  async goruntumAl(id: string, gorunum: string): Promise<Type<any> | null> {
    const tanim = await this.yukle(id);
    if (!tanim) { console.warn(`[DinamikBilesen] '${id}' yüklenemedi`); return null; }

    let comp = (tanim as any)[gorunum];
    if (!comp && gorunum.endsWith('_sade')) {
      comp = (tanim as any)[gorunum.replace('_sade', '')];
    }
    if (!comp) console.warn(`[DinamikBilesen] '${id}' keys:`, Object.keys(tanim), Object.getOwnPropertyNames(tanim));
    return comp && typeof comp === 'function' ? comp : null;
  }

  tumIdler(): string[] {
    return Array.from(this.kayitlar.keys());
  }

  tumKayitlar(): IDinamikBilesenKayit[] {
    return Array.from(this.kayitlar.values());
  }

  kategoriyeGore(kategori: string): IDinamikBilesenKayit[] {
    return this.tumKayitlar().filter(k => k.meta?.kategori === kategori);
  }

  metaAl(id: string): IDinamikBilesenMeta | undefined {
    return this.kayitlar.get(id)?.meta;
  }

  varMi(id: string): boolean {
    return this.kayitlar.has(id);
  }

  get istatistikler() {
    return { kayitli: this.kayitlar.size, yuklenen: this.cache.size };
  }
}

export const DinamikBilesenRegistry = new _DinamikBilesenRegistry();
